const MC_WISHLIST_KEY = 'mega_cortez_wishlist';

function mcGetWishlist() {
try {
return JSON.parse(localStorage.getItem(MC_WISHLIST_KEY)) || [];
} catch (error) {
return [];
}
}

function mcSaveWishlist(items) {
localStorage.setItem(MC_WISHLIST_KEY, JSON.stringify(items));
}

function mcRefreshWishlistButtons() {
const wishlist = mcGetWishlist();

document.querySelectorAll('.mc-wishlist-button').forEach((button) => {
const handle = button.dataset.wishlistHandle;
const isActive = wishlist.includes(handle);

button.classList.toggle('is-active', isActive);
button.setAttribute('aria-pressed', isActive ? 'true' : 'false');

const title = button.dataset.wishlistTitle || 'proizvod';

button.setAttribute(
'aria-label',
isActive
? `Ukloni ${title} iz liste želja`
: `Dodaj ${title} u listu želja`
);
});
}

document.addEventListener('click', (event) => {
const button = event.target.closest('.mc-wishlist-button');

if (!button) return;

event.preventDefault();
event.stopPropagation();

const handle = button.dataset.wishlistHandle;

if (!handle) return;

let wishlist = mcGetWishlist();

if (wishlist.includes(handle)) {
wishlist = wishlist.filter((item) => item !== handle);
} else {
wishlist.push(handle);
}

mcSaveWishlist(wishlist);
mcRefreshWishlistButtons();

document.dispatchEvent(
new CustomEvent('mc:wishlist-change', {
detail: {
wishlist,
count: wishlist.length
}
})
);
});

document.addEventListener('DOMContentLoaded', mcRefreshWishlistButtons);

document.addEventListener('shopify:section:load', mcRefreshWishlistButtons);

window.addEventListener('pageshow', mcRefreshWishlistButtons);
